import axios from "~/plugins/axios";

export default {
  allWithEmployees(includes = ["departments.employees"]) {
    return axios.get("/web_api/v1/agency/with_employees", {
      params: { includes },
    }).then((response) => response.data);
  },

  findByPorCode(PORCode, includes = null) {
    return axios.get(`/web_api/v1/agency/by_por_code/${PORCode}`, {
      params: { includes },
    }).then((response) => response.data);
  },

  searchByName(name) {
    return axios.post("/web_api/v1/agency/search/by_name", { query: name })
      .then((response) => response.data);
  },

  paginate(page = 1, perPage = 15, includes = []) {
    return axios.get("/web_api/v1/agency", { params: { includes, page, perPage } })
      .then((response) => response.data);
  },

  getAgenciesByIds(agencyIds) {
    return axios.post("/web_api/v1/agency/by_ids", { agency_ids: agencyIds })
      .then((response) => response.data);
  },

  getByStaticSearchHash(staticSearchId) {
    return axios.get(`/web_api/v1/agency/by_static_search/${staticSearchId}`)
      .then((response) => response.data);
  },

  find(agencyId, includes = []) {
    return axios.get(`/web_api/v1/agency/${agencyId}`, {
      params: { includes },
    }).then((response) => response.data);
  },

  getByCustomer(customerId, includes = []) {
    return axios.get(`/web_api/v1/agency/by_customer/${customerId}`, {
      params: { includes },
    }).then((response) => response.data);
  },

  getForFamilyByCustomer(customerId, includes = []) {
    return axios.get(`/web_api/v1/agency/for_family_by_customer/${customerId}`, {
      params: { includes },
    }).then((response) => response.data);
  },
};
